module.exports = __webpack_public_path__ + "img/platform_2_tablet.937dcb8.jpg";